import { useEffect, useState } from 'react'
import SelectSearch from '.'
import useAxios from '../../hooks/useAxios'
import { PaginationResponseInterface } from '../../types/pagination'
import { IPipeline } from '../../types/pipeline'
import SelectSearchMultiple, { IOptionSelect } from '../SelectSearchMultiple'

interface Props {
  handleFilterChange?: (filter: any) => void
  selected?: string[]
  onSelect: (e: any) => void
  resetAutoComplete?: string
  label?: string
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  helperText?: string | any
  error?: boolean | any
  name?: string
  multiple?: boolean
  defaultValue?: any
}

const PipelineSelectSearch = (props: Props) => {
  const {
    handleFilterChange,
    selected,
    onSelect,
    resetAutoComplete = '',
    label = 'เลือก pipeline',
    multiple = true,
    ...rest
  } = props
  const [search, setSearch] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [debouncedSearch, setDebouncedSearch] = useState<string>(search)

  const { data, isLoading } = useAxios<PaginationResponseInterface<IPipeline>>({
    method: 'GET',
    url: '/pipeline',
    params: {
      page: 1,
      perPage: 15,
      search: debouncedSearch,
      startDate: '',
      endDate: '',
    },
  })

  useEffect(() => {
    setLoading(true)
    const handler = setTimeout(() => {
      setDebouncedSearch(search)
      setLoading(false)
    }, 1000)

    return () => {
      clearTimeout(handler)
      setLoading(false)
    }
  }, [search])

  const handleSearch = async (value: string) => {
    setSearch(value)
  }

  const currentLoadingState = loading || isLoading

  return (
    <>
      {multiple ? (
        <SelectSearchMultiple<IPipeline>
          resetAutoComplete={resetAutoComplete}
          label={`${label} ${currentLoadingState ? 'กำลังโหลด...' : ''}`}
          onSelect={onSelect}
          search={search}
          onSearch={handleSearch}
          options={
            data?.records
              .filter(
                (pipeline: IPipeline) => !selected?.includes(pipeline.objectId),
              )
              .map((pipeline: IPipeline) => ({
                label: pipeline.name,
                value: pipeline,
              })) || ([] as IOptionSelect<IPipeline>[])
          }
        />
      ) : (
        <SelectSearch<IPipeline>
          {...rest}
          resetAutoComplete={resetAutoComplete}
          label={`${label} ${currentLoadingState ? 'กำลังโหลด...' : ''}`}
          onSelect={onSelect}
          search={search}
          onSearch={handleSearch}
          options={
            data?.records.map((pipeline: IPipeline) => ({
              label: pipeline.name,
              value: pipeline,
            })) || ([] as IOptionSelect<IPipeline>[])
          }
        />
      )}
    </>
  )
}

export default PipelineSelectSearch
